export default function Resume() {
  return (
    <div>
      {/* Prompt: open resume.pdf */}
      <div className="prompt">
        <span className="p-user">vansh</span>
        <span className="p-sep">@</span>
        <span className="p-user">portfolio</span>
        <span className="p-sep">:</span>
        <span className="p-path">~/resume</span>
        <span className="p-char">$</span>
        <span className="p-cmd">open resume.pdf</span>
      </div>

      <div className="output">
        <iframe
          src="/resume.pdf#toolbar=0&navpanes=0&scrollbar=0"
          title="Resume"
          className="resume-frame"
        />

        <div style={{ marginTop: 12, fontSize: 13 }}>
          <span style={{ color: 'var(--dim)' }}>download → </span>
          <a
            href="/resume.pdf"
            download
            className="download-link"
          >
            resume.pdf
          </a>
        </div>
      </div>

    </div>
  );
}
